import { TabGroup } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";
import RouteTab from "ui/router/components/RouterTabs/RouteTab/RouteTab";
import RouterTabs from "ui/router/components/RouterTabs/RouterTabs";
import useAppTabs from "./hooks/useAppTabs";
import type { RoleDto } from "common/models/api/models/RoleDto";

const AppTabs = ({ selectedRole = undefined }: { selectedRole?: RoleDto }): JSX.Element => {
    const translate = useTranslate();
    const tabs = useAppTabs();

    return (
        <RouterTabs>
            <TabGroup key={selectedRole?.program?.name}>
                {tabs.map((item, index) => (
                    <RouteTab to={item.path} index={index} key={item.label}>
                        {translate(item.label)}
                    </RouteTab>
                ))}
            </TabGroup>
        </RouterTabs>
    );
};

export default AppTabs;
